<svg class="fav-icon" class:active width="19" height="26" viewBox="0 0 24 31" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M1 2C1 1.44772 1.44772 1 2 1H22C22.5523 1 23 1.44771 23 2V28.3915C23 29.1769 22.136 29.6558 21.47 29.2395L13.59 24.3145C12.6172 23.7065 11.3828 23.7065 10.41 24.3145L2.53 29.2395C1.86395 29.6558 1 29.1769 1 28.3915V2Z"
    stroke-width="4"
    stroke-linecap="round"
    stroke-linejoin="round"
    />
</svg>

<style lang="stylus">
  svg
    vertical-align middle
    stroke #DCDCDC

  .active
    fill #D1C6FF
    stroke #D1C6FF
</style>

<script>
  export let active = false;
</script>
